import { render, staticRenderFns } from "./booking-calendar.vue?vue&type=template&id=5348f2c8&"
import script from "./booking-calendar.vue?vue&type=script&lang=js&"
export * from "./booking-calendar.vue?vue&type=script&lang=js&"
import style0 from "./booking-calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports